module.exports = __webpack_public_path__ + "static/japan10-647e58119c22649527fd6fb239b14e5f.jpg";